module.exports = __webpack_public_path__ + "static/media/mask_nifty.96ea7ad5.png";